import { useQuery } from "@tanstack/react-query";
import { service_provider_api_requests, SERVICE_PROVIDER_API } from "..";
import { ProviderViewActivity } from "../activity";

const PATH = "/activity/account-summary";
export const ACCOUNT_SUMMARY_QUERY_KEY = [SERVICE_PROVIDER_API + PATH] as const;

export interface AccountSummaryResponse {
  favoritesCount: number;
  contactsCount: number;
  recentActivity: ProviderViewActivity[];
}

/**
 * Fetches the My Account hub summary in a single call:
 *   - favoritesCount  : saved professionals count
 *   - contactsCount   : total interactions made
 *   - recentActivity  : the 3 most recent interactions for the Recent Activity widget
 *
 * @param enabled pass false to skip (unauthenticated users)
 */
export const useGetAccountSummary = (enabled: boolean = true) => {
  return useQuery<AccountSummaryResponse>({
    queryKey: ACCOUNT_SUMMARY_QUERY_KEY,
    queryFn: () => service_provider_api_requests.get(PATH),
    enabled,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};
